import React, { useMemo } from 'react';
import { useStepEditorContext } from 'src/store/step-editor';
import { useEditorContext } from 'src/store/editor';

import { apiDetachNodeFromSynced, apiReplaceNodeInJourney } from 'src/utils/journeyApi';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { useEditorNavigator } from 'src/editor/use-editor-navigator.hook';
import { findNodeInStep } from 'src/utils/journey';

export const StepEditorContentFormSubmitButtons = () => {
  const { node_id } = useStepEditorContext();
  const { currentStep, journey, updateNodeInJourney, setJourney } = useEditorContext();
  const { setSuccessNotification } = useNotificationMessage();
  const { navigateToContentEdit } = useEditorNavigator();

  const currentNode = useMemo(
    () => (!currentStep || !node_id ? null : findNodeInStep(currentStep, node_id)),
    [currentStep, node_id]
  );

  const onDetachClick = () => {
    apiDetachNodeFromSynced(currentNode.id, journey.workspace.id).then((nodeResponse) => {
      apiReplaceNodeInJourney(journey.uuid, currentStep!.id, currentNode.uuid, nodeResponse.uuid).then((journey) => {
        setJourney(journey);

        updateNodeInJourney(nodeResponse, currentStep);
        setSuccessNotification('Synced step successfully detached');
        navigateToContentEdit(currentStep!.id, nodeResponse.id, { replaceHistory: true });
      });
    });
  };

  if (currentNode && currentNode.is_synced) {
    return (
      <div className='flex flex-col space-y-sm'>
        <button type='button' className='btn-bedrock-secondary' onClick={onDetachClick}>
          Detach Step
        </button>
      </div>
    );
  }

  return null;
};
